import { ReactNode } from "react";
import clsx from "clsx";

interface SectionProps {
    id?: string;

    title: string;

    subtitle?: string;

    children: ReactNode;

    className?: string;
}

export function Section({
    id,
    title,
    subtitle,
    children,
    className,
}: SectionProps) {
    return (
        <section
            id={id}
            className={clsx(
                "py-20",
                className
            )}
        >
            <div className="mx-auto max-w-7xl">

                <div className="max-w-3xl">

                    <h2 className="font-heading text-4xl font-bold">

                        {title}

                    </h2>

                    {subtitle && (

                        <p className="mt-5 text-lg leading-8 text-muted-foreground">

                            {subtitle}

                        </p>

                    )}

                </div>

                <div className="mt-12">

                    {children}

                </div>

            </div>

        </section>
    );
}